import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";

export const MessagesHeader = ({ userRole, title }) => {
  const navigate = useNavigate();

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 }
    }
  };

  return (
    <motion.div
      variants={itemVariants}
      className="flex flex-col-reverse xs:flex-row items-start gap-8 md:items-center justify-between"
    >
      <h1 className="text-3xl py-1 md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary via-purple-500 to-accent self-center">
        {title}{" "}
      </h1>
      <Button
        variant="outline"
        onClick={() =>
          navigate(userRole == "buyer" ? "/profile" : "/dashboard")
        }
      >
        <ArrowLeft className="mr-2 h-4 w-4" />{" "}
        {userRole == "buyer" ? "Back to Profile" : "Back to Dashboard"}
      </Button>
    </motion.div>
  );
};
